import axios from 'axios';

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL ?? '',
});

const getCookieValue = (name: string): string | null => {
  if (typeof document === "undefined") return null;
  const cookies = document.cookie ? document.cookie.split("; ") : [];
  for (const cookie of cookies) {
    const [key, ...rest] = cookie.split("=");
    if (key === name) {
      return decodeURIComponent(rest.join("="));
    }
  }
  return null;
};

apiClient.interceptors.request.use((config) => {
  try {
    const headers = (config.headers ?? {}) as Record<string, string>;
    const token = localStorage.getItem('auth_token') || getCookieValue('auth_token');
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    let tenantId: string | undefined;
    const tenant = localStorage.getItem('currentTenant');
    if (tenant) {
      const parsed = JSON.parse(tenant);
      tenantId = parsed?.id;
    }
    if (!tenantId) {
      const userData = localStorage.getItem('user_data');
      if (userData) {
        try {
          const user = JSON.parse(userData);
          tenantId = user?.tenant_id;
        } catch {
          // ignore
        }
      }
    }
    if (!tenantId) {
      const cookieUserData = getCookieValue('user_data');
      if (cookieUserData) {
        try {
          const user = JSON.parse(cookieUserData);
          tenantId = user?.tenant_id;
        } catch {
          // ignore
        }
      }
    }
    if (tenantId) {
      headers['X-Tenant-ID'] = tenantId;
    }
    config.headers = headers as any;
  } catch {
    // ignore
  }

  return config;
});

export default apiClient;
